import { differenceInDays, parseISO } from 'date-fns';

(function() {
    'use strict';
    const pageWrapper = document.querySelector('body');
    const opportunityLinks = document.querySelectorAll('.online-portal-result');
    const newTags = document.querySelectorAll('.online-portal-result__new-badge');

    opportunityLinks.forEach(link => {
        const linkUrl = link.href + '';

        link.addEventListener('click', (e) => {
            e.preventDefault();
            const slideContainer = document.createElement('div');
            slideContainer.classList.add('dialog__wrapper');
            const slideInner = document.createElement('div');
            slideInner.classList.add('dialog__inner');

            const closeButton = document.createElement('button');

            closeButton.classList.add('dialog__close', 'close__button');
            closeButton.innerHTML = 'Back'

            fetch(linkUrl).then((response) => {
                return response.text()
            }).then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");
                const opportunityBody = doc.querySelector('.opportunity-page__wrapper').innerHTML;
                slideInner.innerHTML = opportunityBody;

                slideInner.prepend(closeButton);
                slideContainer.append(slideInner);
                pageWrapper.append(slideContainer);
                slideInner.classList.add('slidein__left');

                const newbadge = slideInner.querySelectorAll('.online-portal-result__new-badge');
                checkNewTags(newbadge);

                closeButton.addEventListener('click', () => {
                    slideInner.classList.add('slidein__right');
                    setTimeout(() => {
                        slideContainer.remove();
                    }, 300);
                })

            })


        });
    });

    // Show new tag
    const checkNewTags = (links) => {
        links.forEach((link) => {
            const linkDate = parseISO(link.dataset.date);
            const todaysDate = new Date();
            const daysDifference = differenceInDays(todaysDate, linkDate);
            if (daysDifference < 3) {
                link.classList.add('show');
            }
        })

    }

    checkNewTags(newTags);

}());